import apiFetch from '../apiFetch'

export default function (values, token) {
  return apiFetch({endPoint: `Planning/generarExcelSugerenciasExtraccionPlanning`, method: 'POST', body: values, token: token})
}